import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

export function LeadSelect(props: any) {
    const handleChange = (event: SelectChangeEvent) => {
        props.setArrayState(
            props.index,
            event.target.value,
            props.setLeadTimes,
            props.leadTimes
        );
    };

    return (
        <Box sx={{ minWidth: 60 }}>
            <FormControl
                variant="standard"
                fullWidth
                sx={{
                    '.MuiInput-root': {
                        marginTop: 0,
                        marginBottom: '16px',
                    },
                    '.MuiSelect-select': {
                        height: '18px',
                        minHeight: '',
                    },
                }}
            >
                <InputLabel
                    id="demo-simple-select-label"
                    sx={{
                        position: 'absolute',
                        top: '18px',
                        overflow: 'display',
                        '& .MuiInput-root': {
                            marginTop: 0,
                        },
                    }}
                >
                    {props.label && 'Lead Time'}
                </InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={props.leadTimes[props.index]}
                    label="Store"
                    onChange={handleChange}
                    sx={{
                        marginTop: '0',
                        textAlign: 'center',
                        height: '18px',
                        minHeight: '',
                    }}
                >
                    {props.options.map((option: number) => {
                        return (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        </Box>
    );
}
